export const VAT_LABEL_TO_PERCENT = {
  A: 21,
  B: 12,
  C: 6,
  D: 0,
  X: null,
};

export function vatLabelToPercent(label) {
  if (label === null || label === undefined || label === '') return null;
  const key = String(label).trim().toUpperCase();
  return Object.prototype.hasOwnProperty.call(VAT_LABEL_TO_PERCENT, key)
      ? VAT_LABEL_TO_PERCENT[key]
      : null;
}

export function vatPercentToLabel(percent) {
  if (percent === null || percent === undefined || percent === '') return null;
  const entry = Object.entries(VAT_LABEL_TO_PERCENT).find(([, value]) => value !== null && value === Number(percent));
  return entry ? entry[0] : null;
}

export function isZeroVat(value) {
  if (value === null || value === undefined || String(value).trim() === '') return false;
  if (String(value).trim().toUpperCase() === 'D') return true;
  return Number(value) === 0;
}

export function hasZeroVat(product) {
  if (!product) return false;
  return [product.vatIn, product.vatOut, product.vatLabelIn, product.vatLabelOut].some((value) => isZeroVat(value));
}

export const VAT_LABEL_OPTIONS = [
  {name: "A (21%)", value: "A"},
  {name: "B (12%)", value: "B"},
  {name: "C (6%)", value: "C"},
  {name: "D (0%)", value: "D"},
  {name: "X (-)", value: "X"},
];

const EXTRA_VAT_RATE_ORG_IDS = [132, 492];

export function vatOptions({blackbox = false, orgId = null} = {}) {
  if (blackbox) return [...VAT_LABEL_OPTIONS];

  const options = [
    {name: "0%", value: 0},
    {name: "6%", value: 6},
    {name: "12%", value: 12},
    {name: "21%", value: 21},
  ];

  if (EXTRA_VAT_RATE_ORG_IDS.includes(Number(orgId))) {
    options.splice(3, 0, {name: "20%", value: 20});
  }

  return options;
}

const VAT_NUMBER_FORMAT = /^[A-Z]{2}(?=[A-Z0-9]*[0-9])[A-Z0-9]{8,15}$/;

export function normalizeVatNumber(value) {
  return String(value ?? '').replace(/[\s.-]/g, '').toUpperCase();
}

export function isValidVatNumber(value) {
  return VAT_NUMBER_FORMAT.test(normalizeVatNumber(value));
}
